export default function getTestSelector (inputProps, str = 'menu') {
	if (inputProps && inputProps['data-test']) {
		return `${inputProps['data-test']}-${str}`;
	}
	else {
		return "";
	}
}